import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  // About aur Blog yahan add kar diye hain
  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ];

  const closeMenu = () => setIsOpen(false);

  return (
    <nav className="sticky top-0 z-[100] bg-gray-900 border-b border-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-6 h-20 flex justify-between items-center">
        
        {/* Logo Section */}
        <Link to="/" onClick={closeMenu} className="flex items-center gap-3 group">
          <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center overflow-hidden transition-transform group-hover:rotate-6">
            <img 
              src="/logo.jpeg" 
              alt="ZYGMA Growth Solutions Logo" 
              className="w-full h-full object-cover"
              onError={(e) => e.target.style.display = 'none'} 
            />
          </div>
          <span className="text-2xl font-black text-blue-500 tracking-tighter">
            ZYGMA.
          </span>
        </Link>

        {/* Desktop Menu */}
        <div className="hidden md:flex gap-8 items-center text-sm font-bold">
          {navLinks.map((link, i) => (
            // Agar Services hai to anchor tag (#) warna normal Link
            link.name === 'Services' ? (
              <a key={i} href="services/1" className="text-gray-400 hover:text-blue-500 transition-colors">
                {link.name}
              </a>
            ) : (
              <Link key={i} to={link.path} className="text-gray-400 hover:text-blue-500 transition-colors">
                {link.name}
              </Link>
            )
          ))}
          <Link to="/contact">
            <button className="bg-blue-600 text-white px-6 py-2.5 rounded-full hover:bg-blue-700 transition-all font-bold">
              Let's Talk
            </button>
          </Link>
        </div>

        {/* Mobile Toggle Button */}
        <div className="md:hidden flex items-center">
          <button 
            onClick={() => setIsOpen(!isOpen)} 
            className="text-gray-400 p-2 focus:outline-none"
          >
            {isOpen ? <X size={32} className="text-blue-500" /> : <Menu size={32} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`
        fixed inset-0 top-20 bg-gray-900/95 backdrop-blur-lg transition-all duration-300 md:hidden
        ${isOpen ? 'opacity-100 visible translate-y-0' : 'opacity-0 invisible -translate-y-5'}
      `}>
        <div className="flex flex-col items-center justify-center h-full space-y-8 pb-32">
          {navLinks.map((link, i) => (
            link.name === 'Services' ? (
              <a 
                key={i} 
                href="#services" 
                onClick={closeMenu}
                className="text-3xl font-black text-white hover:text-blue-500 transition-colors"
              >
                {link.name}
              </a>
            ) : (
              <Link 
                key={i} 
                to={link.path} 
                onClick={closeMenu}
                className="text-3xl font-black text-white hover:text-blue-500 transition-colors"
              >
                {link.name}
              </Link>
            )
          ))}
          
          <Link to="/contact" onClick={closeMenu} className="pt-6">
            <button className="bg-blue-600 text-white px-12 py-4 rounded-2xl text-xl font-bold shadow-2xl shadow-blue-600/20">
              Get Started
            </button>
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;